var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeechBubble9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2857 18.129C19.4416 18.129 22 15.5804 22 12.4364C22 9.94468 20.393 7.82685 18.1551 7.05542C17.8371 4.2114 15.4159 2 12.4762 2C9.32028 2 6.7619 4.54866 6.7619 7.6926C6.7619 8.38797 6.88706 9.05423 7.11616 9.67023C6.8475 9.61767 6.56983 9.59013 6.28571 9.59013C3.91878 9.59013 2 11.5016 2 13.8596C2 15.7468 3.22919 17.3481 4.93352 17.9122C4.54221 18.5618 3.94598 19.0815 3.10041 19.6041C2.9075 19.7234 3.01441 20.0387 3.23604 19.9961C5.58912 19.544 6.87977 18.9308 7.7025 18.129H16.2857ZM9 12C9 12.5523 8.55228 13 8 13C7.44772 13 7 12.5523 7 12C7 11.4477 7.44772 11 8 11C8.55228 11 9 11.4477 9 12ZM13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12ZM16 13C15.4477 13 15 12.5523 15 12C15 11.4477 15.4477 11 16 11C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble9);
export default __webpack_public_path__ + "static/media/speech-bubble-9.339e540c8625bccf86d688a74ee4eceb.svg";
export { ForwardRef as ReactComponent };